import { DotsVerticalIcon } from '@langchain/untitled-ui-icons';
import { PopoverPortal } from '@radix-ui/react-popover';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';

export const AdditionalActionsHeaderButton = ({
  onRemoveComparison,
  onEditExperimentName,
}: {
  onRemoveComparison?: () => void;
  onEditExperimentName?: () => void;
}) => {
  if (!onRemoveComparison && !onEditExperimentName) return null;
  return (
    <Popover>
      <PopoverTrigger>
        <div className="rounded-md p-1 text-quaternary hover:bg-tertiary">
          <DotsVerticalIcon className="my-auto h-4 w-4" />
        </div>
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          sideOffset={5}
          align="end"
          className="relative z-[999] w-fit p-2"
        >
          {onRemoveComparison && (
            <button
              type="button"
              onClick={onRemoveComparison}
              className="flex items-center gap-2 rounded-md px-2 py-1 text-sm font-medium text-secondary hover:bg-secondary"
            >
              Remove Comparison
            </button>
          )}
          {onEditExperimentName && (
            <button
              type="button"
              onClick={onEditExperimentName}
              className="flex items-center gap-2 rounded-md px-2 py-1 text-sm font-medium text-secondary hover:bg-secondary"
            >
              Edit Experiment Name
            </button>
          )}
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
};
